import React from "react";

function NXMonitor({ className }: {className: any}) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4286_2825)">
        <path
          d="M6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99512 9.99511L13.0001 13.0001"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.51562 6.15625H4.04688L5.07813 4.1875L6.64062 7.8125L7.98438 6.15625H9.48438"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4286_2825">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXMonitor;
